/*
  Usage note:
  withContext should be the first param of pipe fn due to injected props from react_on_rails
*/
import React, { createContext } from 'react';

export const AppContext = createContext();

export default Comp => props => (
  <AppContext.Provider value={props}>
    <Comp />
  </AppContext.Provider>
);
